import { Component, OnInit } from '@angular/core';
import { DataService } from './shared/dataservice.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  public options = {
    position: ["top", "right"],
    timeOut: 5000,
    lastOnBottom: true,
    showProgressBar:true,
    clickToClose:true
  };
  title = 'app';
  extraErrorMessage = 'loading...';
  errorCount:number = 0;

  constructor(public _dataService: DataService,private router: Router){
    
  }

  ngOnInit(){
    this.initApp();
    this.checkLoadErrors();
  }

  private checkLoadErrors(){
    setTimeout(() => {
      if(this._dataService.isBasicDataLoaded == false){
        this.errorCount++;
        if(this.errorCount == 1)
          this.extraErrorMessage = "this is taking longer...";
        else if(this.errorCount == 2)
          this.extraErrorMessage = "try reloading the page...";
        else  
          return;
        
        this.checkLoadErrors();
      }
    }, 3000);
  }

  private initApp(){
  
    this._dataService.getProductGroupInfo().subscribe((_RetVal:boolean) => {
        if(_RetVal == false){
          setTimeout(() => {
            this.initApp();
          }, 100);
        }
        else{
          //if(this._dataService.isAdmin == 'false'){
            if(this._dataService.hasDownloadAccess == true){
              this.router.navigate(["rtcdownload"]);
            }
            else if(this._dataService.hasUploadAccess == true){
              this.router.navigate(["rtcupload"]);
            }
            else if(this._dataService.hasDrawDownloadAccess == true){
              this.router.navigate(["drawdownload"]);
            }
            else if(this._dataService.hasDrawUploadAccess == true){
              this.router.navigate(["drawupload"]);
            }
            else{
              //route to no access
            }
              
          //}
        }
    })
  }
  
}
